import React from 'react';
import styled from 'styled-components';
import { BlueButton } from '../../StyledComponents';
import FirstNameIcon from '../../../assets/formComponents/FirstNameIcon.svg';
import EmailIcon from '../../../assets/formComponents/emailIcon.svg';
import {
  StyledInputs,
  PasswordMatchError,
} from '../../HomePage/EsperSignUpFormComponent';
import Axios from 'axios';
import { Link, navigate } from 'gatsby';
import { validatePhone } from '../../../globalFunctions';
import { RequestDemoFormContainer } from '../BookDemo/RequestDemoForm';
import apiHost from '../../../apiHost';
import Checkbox from '../../UIComponents/Checkbox';
import Fade from 'react-reveal/Fade';
import PhoneInputClass from './PhoneInput';
import { getLanguageFromPath } from '../../../helpers';

export const StyledTextArea = styled.textarea`
  :focus {
    color: #495057;
    background-color: #fff;
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.1rem rgba(0, 123, 255, 0.25);
    color: black;
    background-image: none;
  }
  box-shadow: ${(props: { error: boolean }) =>
    props.error ? '0 0 0 0.1rem #fd7e7e5e' : 'none'};
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  @media (max-width: 520px) {
    font-size: 12px;
    width: 100%;
  }
  line-height: 1.43;
  ::placeholder {
    color: rgba(107, 124, 147, 0.6);
    opacity: 1; /* Firefox */
  }
  padding: 1.07em 0.5em;
  margin-top: 10px;
  height: 100px;
  min-width: 18rem;
  width: 98%;
  @media (min-width: 1280px) {
    min-width: 350px;
  }
  @media (min-width: 780px) and (max-width: 960px) {
    min-width: 350px;
  }
  @media (max-width: 400px) {
    min-width: 230px;
  }
  /* min-width: 15rem; */
  border: solid 2px #cacaca;
  border-color: ${(props: { error: boolean }) =>
    props.error ? '#eb6161' : 'rgba(107, 124, 147, 0.43)'};
  padding: 0.475rem 0.75rem 0.475rem 1.5rem;
  border-radius: 4px;
  background-position-y: center;
  background-position-x: 0.5rem;
  background-repeat: no-repeat;
  text-indent: 20px;
`;

export const RequestDemoFormComponent = styled.div`
  max-width: 90%;
  width: 450px;
  justify-self: left;
  @media (max-width: 780px) {
    justify-self: center;
    width: 350px;
  }
  @media (max-width: 330px) {
    max-width: 18rem;
  }
`;

const BlueButtonNew = styled(BlueButton)`
  width: 95%;
  min-width: 18rem;
  margin-top: 24px;
  @media (min-width: 1280px) {
    min-width: 350px;
  }
  @media (min-width: 780px) and (max-width: 960px) {
    min-width: 350px;
  }
  @media (max-width: 400px) {
    min-width: 250px;
  }
`;

export default class RequestDemoForm extends React.Component<any, any> {
  state = {
    name: '',
    email: '',
    contactNumber: '',
    defaultCountry: {
      icon: '🇺🇲',
      name: 'United States',
      abbr: 'US',
      code: '1',
      suggested: true,
    },
    contactErrorMessage: '',
    description: '',
    contactFocus: false,
    nameError: false,
    descriptionError: false,
    emailError: false,
    contactError: false,
    submitError: false,
    langKey: 'en',
    consentCheckbox: false,
    consentError: false,
  };

  isAllValid = () =>
    !(this.state.contactError ||
    this.state.nameError ||
    this.state.descriptionError ||
    this.state.emailError ||
    this.state.consentError ||
    this.props.messages.locale !== 'en'
      ? !this.state.consentCheckbox
      : false);

  validateAll = () => {
    this.validateContactNumber();
    this.validateFullName();
    this.validateEmail();
    this.validateDescription();
    if (!this.state.consentCheckbox && this.props.messages.locale !== 'en') {
      this.setState({
        consentError: true,
      });
    }
  };

  validateDescription = () => {
    if (
      this.state.description.length === 0 ||
      this.state.description.length > 200
    ) {
      this.setState({
        descriptionError: true,
      });
    } else {
      this.setState({
        descriptionError: false,
      });
    }
  };

  navigateThankyou = () => {
    localStorage.setItem('prevPage', 'contact-us');
    // navigate('/submitted');
    if (this.props.endState) {
      navigate(
        this.state.langKey !== 'en'
          ? `/${this.state.langKey}${this.props.endState}`
          : `${this.props.endState}`
      );
    } else {
      navigate(
        this.state.langKey !== 'en'
          ? `/${this.state.langKey}/submitted`
          : '/submitted'
      );
    }
  };

  getCookieValue = (name: string) => {
    const found = document.cookie
      .split(';')
      .filter((c) => c.trim().split('=')[0] === name);
    return found.length > 0 ? found[0].split('=')[1] : undefined;
  };

  sendData = () => {
    this.validateAll();
    if (this.isAllValid()) {
      const hubspotToken = this.getCookieValue('hubspotutk');
      Axios({
        url:
          'https://api.hsforms.com/submissions/v3/integration/submit/5868902/d0beae09-1219-4751-9160-1a67a2770909',
        method: 'POST',
        data: {
          fields: [
            {
              name: 'email',
              value: this.state.email,
            },
            {
              name: 'firstname',
              value: this.state.name,
            },
            {
              name: 'phone',
              value: `${
                this.state.defaultCountry
                  ? `+${this.state.defaultCountry.code} `
                  : ''
              }${this.state.contactNumber.trim()}`,
            },
            {
              name: 'message',
              value: this.state.description,
            },
            {
              name: 'language_key',
              value: this.state.langKey,
            },
          ],
          context: {
            hutk: hubspotToken,
            pageUri: window.location.href,
            pageName: document.title,
          },
        },
      })
        .then((response: any) => {
          this.setState({
            contactError: false,
            nameError: false,
            emailError: false,
            email: '',
            name: '',
            contactNumber: '',
          });
          this.navigateThankyou();
        })
        .catch((error: any) => {
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            error.response.data.errors.forEach((item: any) => {
              if (item.message.includes('fields.email')) {
                this.setState({ emailError: true });
              } else if (item.message.includes('fields.phone')) {
                this.setState({ contactError: true });
              } else {
                console.log('error');
              }
            });
          }
        });
    } else {
      Axios({
        url: `${apiHost.host}collect-emails`,
        method: 'POST',
        data: {
          email: this.state.email.trim().toLowerCase(),
          page: `Contact Form`,
          failure: true,
          url: window.location.href,
        },
      }).catch(() => {
        console.log('Error collecting email');
      });
    }
  };

  // VALIDATIONS

  validateFullName = () => {
    if (this.state.name.length === 0 || this.state.name.length > 30) {
      this.setState({
        nameError: true,
      });
    } else {
      this.setState({
        nameError: false,
      });
    }
  };
  componentDidMount = () => {
    this.setState({
      langKey: getLanguageFromPath(window.location.pathname)
        ? getLanguageFromPath(window.location.pathname)
        : 'en',
    });
  };

  validateEmail = (isNotOnFocus?: boolean) => {
    const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const result = pattern.test(this.state.email);
    if (result === true && this.state.email.length < 150) {
      Axios({
        url: `${apiHost.host}collect-emails`,
        method: 'POST',
        data: {
          email: this.state.email.trim().toLowerCase(),
          page: `Contact Form`,
          failure: false,
          url: window.location.href,
        },
      }).catch(() => {
        console.log('Error collecting email');
      });
      if (isNotOnFocus) {
        this.setState({
          emailError: false,
          submitError: false,
          emailErrorText: '',
        });
      } else {
        this.setState({
          emailError: false,
          submitError: false,
          emailErrorText: '',
        });
      }
    } else {
      this.setState({
        emailError: true,
      });
    }
  };

  validateContactNumber = () => {
    if (!validatePhone(this.state.contactNumber)) {
      this.setState({
        contactError: true,
        contactFocus: true,
        contactErrorMessage: this.props.messages
          ?.AllFormValidationMessagesValidPhoneNumber,
      });
    } else {
      this.setState({
        contactError: false,
        contactFocus: true,
        contactErrorMessage: '',
      });
    }
  };

  //   Input Recievers

  handleNameChange = (event: any) =>
    this.setState({ name: event.target.value });
  handleEmailChange = (event: any) =>
    this.setState({ email: event.target.value });
  handleContactChange = (event: any) =>
    this.setState({ contactNumber: event.target.value });
  handleCountrySelect = (event: any) => {
    this.setState({ defaultCountry: event });
  };
  handleDescriptionChange = (event: any) =>
    this.setState({ description: event.target.value });
  handleFocusContact = () => this.setState({ contactFocus: true });
  render() {
    return (
      <RequestDemoFormComponent>
        <RequestDemoFormContainer>
          <div style={{ display: 'grid' }}>
            <StyledInputs
              id="name"
              value={this.state.name}
              backgroundImage={FirstNameIcon}
              aria-label="Full Name"
              maxLength={149}
              onChange={this.handleNameChange}
              onBlur={this.validateFullName}
              error={this.state.nameError || this.state.submitError}
              type="text"
              placeholder={this.props.messages?.ContactUsPageFormName}
              name="Full Name"
            />
            <PasswordMatchError id="name-error">
              {this.state.nameError === false && this.state.submitError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  Please enter a valid name
                </>
              ) : (
                this.state.nameError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.state.name.length > 1
                      ? 'Please enter a valid name'
                      : this.props.messages?.AllFormValidationMessagesName ??
                        'Please enter the name'}
                  </>
                )
              )}
            </PasswordMatchError>
          </div>
          <div style={{ display: 'grid' }}>
            <StyledInputs
              id="email"
              value={this.state.email}
              backgroundImage={EmailIcon}
              aria-label="Email"
              maxLength={149}
              onChange={this.handleEmailChange}
              onBlur={this.validateEmail}
              error={this.state.emailError || this.state.submitError}
              type="email"
              placeholder={this.props.messages?.ContactUsPageFormEmail}
              name="Work Email"
            />
            <PasswordMatchError id="email-error">
              {this.state.emailError === false && this.state.submitError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  {this.props.messages?.AllFormValidationMessagesValidEmail}
                </>
              ) : (
                this.state.emailError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.state.email.length > 1
                      ? this.props.messages?.AllFormValidationMessagesValidEmail
                      : this.props.messages?.AllFormValidationMessagesEmail}
                  </>
                )
              )}
            </PasswordMatchError>
          </div>
          <PhoneInputClass
            handleFocusContact={this.handleFocusContact}
            handleContactChange={this.handleContactChange}
            validateContactNumber={this.validateContactNumber}
            handleCountrySelect={this.handleCountrySelect}
            defaultCountry={this.state.defaultCountry}
            contactNumber={this.state.contactNumber}
            contactError={this.state.contactError}
            submitError={this.state.submitError}
            messages={this.props.messages}
          />
          <div
            style={{
              display: 'grid',
            }}
          >
            <StyledTextArea
              id="description"
              aria-label="description"
              error={this.state.descriptionError}
              onBlur={this.validateDescription}
              value={this.state.description}
              //   maxLength={15}
              minLength={14}
              maxLength={200}
              onChange={this.handleDescriptionChange}
              placeholder={this.props.messages?.ContactUsPageFormQues}
              name="description"
            />
            <PasswordMatchError id="description-error">
              {this.state.descriptionError === true && (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  {this.props.messages?.AllFormValidationMessagesReq ??
                    'Please enter your requirements'}
                </>
              )}
            </PasswordMatchError>
          </div>
          <div
            style={{
              display: 'grid',
              maxWidth: '420px',
            }}
          >
            {this.props?.messages?.locale === 'de' ? (
              <Checkbox
                label={
                  <div style={{ textAlign: 'left' }}>
                    {this.props.messages?.locale ? (
                      <div>
                        {this.props.messages?.WebsiteConsentText1}
                        <Link
                          to={`${
                            this.props?.messages?.locale !== 'en'
                              ? `/${this.props?.messages?.locale}/privacy-policy`
                              : '/privacy-policy'
                          }`}
                        >
                          {' '}
                          {this.props.messages?.WebsiteConsentText2}{' '}
                        </Link>
                        {this.props.messages?.WebsiteConsentText3}
                      </div>
                    ) : (
                      <div>
                        {
                          'By submitting this form, you consent to the collection and processing of your personal data under the terms set out in our'
                        }{' '}
                        <Link
                          to={`${
                            this.props?.messages?.locale !== 'en'
                              ? `/${this.props?.messages?.locale}/privacy-policy`
                              : '/privacy-policy'
                          }`}
                        >
                          {' privacy policy.'}
                        </Link>
                        {
                          'You have the right to access, modify and delete your personal data. You can exercise this right by contacting partner@esper.io. You can unsubscribe from these communications at any time. '
                        }
                      </div>
                    )}
                  </div>
                }
                checked={this.state.consentCheckbox}
                onChange={() =>
                  this.setState(
                    {
                      consentCheckbox: !this.state.consentCheckbox,
                    },
                    () =>
                      this.setState({
                        consentError:
                          this.state.consentError && !this.state.consentCheckbox
                            ? true
                            : false,
                      })
                  )
                }
              />
            ) : this.props?.messages?.locale === 'en' ? (
              <div style={{ textAlign: 'left', marginTop: '-5px' }}>
                <Checkbox
                  label={
                    <div style={{ textAlign: 'left' }}>
                      {this.props.messages?.locale ? (
                        <div>{this.props.messages?.WebsiteConsentText1}</div>
                      ) : (
                        <div>
                          {
                            'By submitting this form, you consent to the collection and processing of your personal data under the terms set out in our'
                          }{' '}
                          <Link
                            to={`${
                              this.props?.messages?.locale !== 'en'
                                ? `/${this.props?.messages?.locale}/privacy-policy`
                                : '/privacy-policy'
                            }`}
                          >
                            {' privacy policy.'}
                          </Link>
                          {
                            'You have the right to access, modify and delete your personal data. You can exercise this right by contacting partner@esper.io. You can unsubscribe from these communications at any time. '
                          }
                        </div>
                      )}
                    </div>
                  }
                  checked={this.state.consentCheckbox}
                  onChange={() =>
                    this.setState({
                      consentCheckbox: !this.state.consentCheckbox,
                    })
                  }
                />
              </div>
            ) : null}
            <Fade when={this.state.consentError}>
              <PasswordMatchError id="consent-error">
                {this.state.consentError === true && (
                  <>
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.props.messages?.WebsiteConsentErrorValidationText}
                  </>
                )}
              </PasswordMatchError>
            </Fade>
          </div>
          <div style={{ display: 'grid', marginTop: '-20px' }}>
            <BlueButtonNew id="request_demo__send" onClick={this.sendData}>
              {this.props.messages?.ContactUsPageFormSendButton}
            </BlueButtonNew>
          </div>
          {this.props?.messages?.locale !== 'de' ? (
            <div style={{ marginTop: '15px' }}>
              {this.props.messages?.WebsiteConsentText2}
              <Link
                to={`${
                  this.props?.messages?.locale !== 'en'
                    ? `/${this.props?.messages?.locale}/terms-of-service/`
                    : '/terms-of-service/'
                }`}
              >
                {' '}
                {this.props.messages?.WebsiteConsentText3}
              </Link>
              <Link
                to={`${
                  this.props?.messages?.locale !== 'en'
                    ? `/${this.props?.messages?.locale}/privacy-policy`
                    : '/privacy-policy'
                }`}
              >
                {' '}
                {this.props.messages?.WebsiteConsentText4}{' '}
              </Link>
            </div>
          ) : null}
        </RequestDemoFormContainer>
      </RequestDemoFormComponent>
    );
  }
}
